import React, { FunctionComponent } from "react";
import {
    Modal,
    PrimaryButton,
    IconButton
} from "@fluentui/react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
    contentStyles as content,
    iconButtonStyles,
    cancelIcon,
} from "constants/styles";
import { CustomFontText } from "components/customFontText/CustomFontText";
import { Col, Row } from "react-grid-system";

const contentStyles = content(600, "auto");

interface IProps {
    onDismiss: () => void;
    isOpen: boolean;
    handleImportVehicle: (data: any) => void;
    vehicle: any
}

export const ImportTradeInLeadDialog: FunctionComponent<IProps> = ({
    onDismiss,
    isOpen,
    handleImportVehicle,
    vehicle
}) => {

    return (
        <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            isBlocking={true}
            containerClassName={contentStyles.container + " custom-modal"}
            className="vehicleFoundDialog"
        >
            <div className={contentStyles.header + " inventory-popup"}>
                {/*<GoBackToMainDialogBtn label="" onClick={onDismiss} />*/}
                <CustomFontText className="formTitle"> Trade-In Found
                </CustomFontText>

                <IconButton
                    styles={iconButtonStyles}
                    iconProps={cancelIcon}
                    ariaLabel="Close popup modal"
                    onClick={onDismiss}
                />
            </div>
            <div className="leadNotFound body-auto-hight body-min-height-50">
                <div style={{ marginLeft: "25px", textAlign: "left" }}>

                    <label className="lbl-text">Do you want to import the trade-in vehicle attached to this lead?</label>

                </div>
                <div style={{ marginLeft: "25px", textAlign: "left" ,maxHeight:'250px'}}>
                  
                        <Row>
                            <Col style={{ display: 'flex', marginTop: '10px' }}
                            >
                                <label  style={{ display: 'flex' }} className="radio-option">
                                    <div>

                                                <div>
                                            <div>VIN: {vehicle.vin ? vehicle.vin : "No data"}</div>
                                            <div>
                                                YMM: {vehicle.year ? `${vehicle.year} ${vehicle.make} ${vehicle.model}` : "No data"}
                                            </div>
                                            <div>Trim: {vehicle.trim ? vehicle.trim : "No data"}</div>
                                        </div>
                                    </div>
                                </label>
                            </Col>
                        </Row>
                </div>
            </div>


            <div className={contentStyles.footer + " display-row-center inventory-popup-footer"} >
                <Row className="display-row-center inventoryRowSection footerBtn cusNoNotFoundFoot">
                    <Col>
                        <PrimaryButton
                            style={{ float: "left" }}
                            onClick={handleImportVehicle}
                            text="Import Trade-In"
                            className="cusNoNotFoundDiaBtnHeight"
                        />
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};



